const AsscherDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M82.09,95.55c0.04,0,0.08-0.01,0.12-0.02c0.04-0.01,0.07-0.03,0.11-0.05c0.02-0.01,0.04-0.01,0.06-0.03
	c0.02-0.01,0.02-0.03,0.04-0.04c0.01-0.01,0.03-0.02,0.04-0.03l12.93-12.93c0.01-0.01,0.02-0.03,0.03-0.04
	c0.01-0.01,0.03-0.02,0.04-0.04c0.01-0.02,0.02-0.04,0.03-0.06c0.02-0.03,0.03-0.07,0.05-0.1c0.01-0.04,0.02-0.08,0.03-0.13
	c0-0.02,0.01-0.03,0.01-0.05V17.96c0-0.02-0.01-0.04-0.01-0.05c0-0.04-0.01-0.08-0.02-0.12c-0.01-0.04-0.03-0.07-0.05-0.11
	c-0.01-0.02-0.01-0.04-0.03-0.06c-0.01-0.02-0.03-0.02-0.04-0.04c-0.01-0.01-0.02-0.03-0.03-0.04L82.46,4.61
	c-0.01-0.01-0.03-0.02-0.04-0.03c-0.01-0.01-0.02-0.03-0.04-0.04c-0.02-0.01-0.04-0.02-0.06-0.03c-0.04-0.02-0.07-0.04-0.11-0.05
	c-0.04-0.01-0.08-0.02-0.12-0.02c-0.02,0-0.04-0.01-0.06-0.01H17.96c-0.02,0-0.04,0.01-0.06,0.01c-0.04,0-0.08,0.01-0.12,0.02
	c-0.04,0.01-0.07,0.03-0.11,0.05c-0.02,0.01-0.04,0.01-0.06,0.03c-0.01,0.01-0.02,0.02-0.03,0.03c-0.02,0.01-0.04,0.02-0.05,0.03
	L4.61,17.54c-0.01,0.01-0.02,0.03-0.03,0.04c-0.01,0.01-0.03,0.02-0.04,0.04c-0.02,0.02-0.02,0.05-0.04,0.08
	c-0.01,0.02-0.02,0.04-0.03,0.06c-0.02,0.07-0.04,0.14-0.04,0.21c0,0,0,0,0,0s0,0,0,0v64.07c0,0,0,0,0,0s0,0,0,0
	c0,0.07,0.02,0.14,0.04,0.21c0.01,0.02,0.02,0.04,0.03,0.06c0.01,0.03,0.02,0.05,0.04,0.08c0.01,0.02,0.03,0.02,0.04,0.04
	c0.01,0.01,0.02,0.03,0.03,0.04l12.93,12.93c0.01,0.02,0.04,0.02,0.05,0.03c0.01,0.01,0.02,0.02,0.03,0.03
	c0.02,0.01,0.04,0.02,0.06,0.03c0.04,0.02,0.07,0.04,0.11,0.05c0.04,0.01,0.08,0.02,0.12,0.02c0.02,0,0.04,0.01,0.06,0.01h64.07
	C82.06,95.56,82.07,95.55,82.09,95.55z M5.97,82.12l6.66-4.64l9.9,9.9l-4.64,6.66L5.97,82.12z M5.64,19.11l6.46,4.5v52.77l-6.46,4.5
	V19.11z M17.88,5.97l4.64,6.66l-9.9,9.9l-6.66-4.64L17.88,5.97z M80.89,5.64l-4.5,6.46H23.62l-4.5-6.46H80.89z M94.03,17.88
	l-6.66,4.64l-9.9-9.9l4.64-6.66L94.03,17.88z M94.36,80.89l-6.46-4.5V23.62l6.46-4.5V80.89z M82.12,94.03l-4.64-6.66l9.9-9.9
	l6.66,4.64L82.12,94.03z M24.45,86.7l4.5-6.46h42.09l4.5,6.46H24.45z M13.3,24.45l6.46,4.5v42.09l-6.46,4.5V24.45z M75.55,13.3
	l-4.5,6.46H28.96l-4.5-6.46H75.55z M86.7,75.55l-6.46-4.5V28.96l6.46-4.5V75.55z M20.96,71.11V28.89l7.93-7.93h42.22l7.93,7.93
	v42.22l-7.93,7.93H28.89L20.96,71.11z M72.14,79.71l7.57-7.57l6.66,4.64l-9.59,9.59L72.14,79.71z M79.71,27.86l-7.57-7.57l4.64-6.66
	l9.59,9.59L79.71,27.86z M27.86,20.29l-7.57,7.57l-6.66-4.64l9.59-9.59L27.86,20.29z M20.29,72.14l7.57,7.57l-4.64,6.66l-9.59-9.59
	L20.29,72.14z M23.62,87.9h52.77l4.5,6.46H19.11L23.62,87.9z"
      />
    </svg>
  )
}

export default AsscherDiamond
